// src/admin/Sidebar.jsx
import React from "react";
import { Link, useLocation } from "react-router-dom";

export default function Sidebar() {
  const location = useLocation();

  const links = [
    { title: "Dashboard", path: "/admin" },
    { title: "Manage Home", path: "/admin/pages/home" },
    { title: "Manage About", path: "/admin/pages/about" },
    { title: "Manage Contact", path: "/admin/pages/contact" },
    { title: "Manage Blogs", path: "/admin/pages/blogs" },
    { title: "Manage Portfolio", path: "/admin/pages/portfolio" },
    { title: "Manage Services", path: "/admin/pages/services" },
  ];

  return (
    <aside className="w-64 bg-gray-900 text-white p-4 space-y-2">
      <h1 className="text-xl font-bold mb-6">Admin Panel</h1>
      {links.map((link) => (
        <Link
          key={link.path}
          to={link.path}
          className={`block px-4 py-2 rounded ${
            location.pathname === link.path ? "bg-gray-700" : "hover:bg-gray-800"
          }`}
        >
          {link.title}
        </Link>
      ))}
    </aside>
  );
}
